module.exports = __webpack_public_path__ + "media/images/category/feature/coj_c/hero_mob-bb91619aeb57d68e0ef535eb5c512802.jpg";